import type { JSX } from 'react'
import { Box, Typography, Button } from '@mui/material'
import type { ToolUi } from '../runtime/types'

/**
 * A compact card that presents a navigation suggestion from the advisor.
 * Shows the reason text and a "Go to <pageId>" action button.
 */
export function NavProposal({
  nav,
  onGo,
}: {
  nav: Extract<ToolUi, { kind: 'nav' }>
  onGo: (ui: Extract<ToolUi, { kind: 'nav' }>) => void
}): JSX.Element {
  return (
    <Box
      sx={{
        p: 1,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        display: 'inline-flex',
        flexDirection: 'column',
        gap: 0.5,
        maxWidth: '100%',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {nav.reason}
      </Typography>
      <Button size="small" variant="outlined" onClick={() => onGo(nav)}>
        Go to {nav.pageId}
      </Button>
    </Box>
  )
}
